export class Account {
  id: string;
  name: string;
  roleStatus: string = undefined;
  connectionStatus: string = undefined;
  roleVersion: string = undefined;
  connectionType : string = "assumeRole";
  roleName : string = undefined;
  externalId: string = undefined;
  credentials : {
    accessKeyId: string;
    secretAccessKey: string;
    sessionToken: string;
  } = {
    accessKeyId: "",
    secretAccessKey: "",
    sessionToken: ""
  }
}